// src/views/MyEvents.jsx
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Breadcrumb, Spinner, Alert, Card as BootstrapCard } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";
import { Empty, Tabs, Badge, message } from "antd";
import EventCard from "@/components/Events/EventCard";
import { getAssignedEvents, markEventAsRead, markEventAsUnread } from "@/api/eventApi";

const MyEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getAssignedEvents();
      setEvents(data || []);
    } catch (err) {
      console.error("Error fetching events:", err);
      setError(err.response?.data?.message || "Eventlarni yuklashda xatolik");
      message.error("Eventlarni yuklashda xatolik");
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAsRead = async (eventId) => {
    try {
      await markEventAsRead(eventId);
      message.success("Event o'qilgan deb belgilandi");
      fetchEvents();
    } catch (err) {
      message.error("Xatolik yuz berdi");
    }
  };

  const handleMarkAsUnread = async (eventId) => {
    try {
      await markEventAsUnread(eventId);
      message.success("Event o'qilmagan deb belgilandi");
      fetchEvents();
    } catch (err) {
      message.error("Xatolik yuz berdi");
    }
  };

  const unreadEvents = events.filter((e) => !e.is_read);
  const readEvents = events.filter((e) => e.is_read);

  const tabItems = [
    {
      key: "all",
      label: (
        <span>
          Barchasi <Badge count={events.length} showZero />
        </span>
      ),
      children: (
        <Row>
          {events.map((event) => (
            <Col key={event.id} xs={12} lg={6}>
              <EventCard
                event={event}
                isAdmin={false}
                onMarkAsRead={handleMarkAsRead}
                onMarkAsUnread={handleMarkAsUnread}
              />
            </Col>
          ))}
        </Row>
      ),
    },
    {
      key: "unread",
      label: (
        <span>
          O'qilmagan <Badge count={unreadEvents.length} />
        </span>
      ),
      children: (
        <Row>
          {unreadEvents.length > 0 ? (
            unreadEvents.map((event) => (
              <Col key={event.id} xs={12} lg={6}>
                <EventCard
                  event={event}
                  isAdmin={false}
                  onMarkAsRead={handleMarkAsRead}
                  onMarkAsUnread={handleMarkAsUnread}
                />
              </Col>
            ))
          ) : (
            <Col xs={12}>
              <Empty description="O'qilmagan eventlar yo'q" />
            </Col>
          )}
        </Row>
      ),
    },
    {
      key: "read",
      label: (
        <span>
          O'qilgan <Badge count={readEvents.length} showZero />
        </span>
      ),
      children: (
        <Row>
          {readEvents.length > 0 ? (
            readEvents.map((event) => (
              <Col key={event.id} xs={12} lg={6}>
                <EventCard
                  event={event}
                  isAdmin={false}
                  onMarkAsRead={handleMarkAsRead}
                  onMarkAsUnread={handleMarkAsUnread}
                />
              </Col>
            ))
          ) : (
            <Col xs={12}>
              <Empty description="O'qilgan eventlar yo'q" />
            </Col>
          )}
        </Row>
      ),
    },
  ];

  return (
    <Container fluid className="p-4">
      {/* Breadcrumb */}
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Mening tadbirlarim</Breadcrumb.Item>
      </Breadcrumb>


      {/* Content */}
      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Tadbirlar yuklanmoqda...</p>
        </div>
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : events.length === 0 ? (
        <BootstrapCard>
          <BootstrapCard.Body>
            <Empty
              description="Sizga biriktirilgan eventlar mavjud emas"
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          </BootstrapCard.Body>
        </BootstrapCard>
      ) : (
        <Tabs defaultActiveKey="all" items={tabItems} />
      )}
    </Container>
  );
};

export default MyEvents;
